<template>
	<v-card color="rgba(170,170,170,0.4)" class="" height="380" width="100%" style="overflow-y: auto">
        <v-card-title>
            {{titulos.dados.nome}}
        </v-card-title>
        <v-card-subtitle>
            {{titulos.dados.email}}<br />
            {{titulos.dados.grauAtual}}º grau - {{titulos.dados.claAtual}}
        </v-card-subtitle>
        <v-divider></v-divider>
        <v-card-text>
            <v-data-table hide-default-footer fixed-header :items="titulos.titulos" :headers="fields" :items-per-page="10">
                <template v-slot:item.data="{ item }">
					{{mostrarData(item.data)}}
				</template>
				<template v-slot:item.actions="{ item }">
                    <v-btn text color="primary" @click="editar(item)">
                        <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                    <v-btn :disabled="item.cla == 1" text color="primary" @click="excluir(item)">
                        <v-icon>mdi-delete</v-icon>
                    </v-btn>
                </template>
            </v-data-table>
        </v-card-text>
    </v-card>
	<!-- <div class="titulos">
		<Modal v-if="showModal">
			<h3 slot="header">{{registro.nome}}</h3>
			<div slot="body">
				<h4>Você confirma a exclusão do título?</h4>
			</div>
			<div slot="footer">
				<button class="modal-default-button" @click="excluir">Confirmar</button>
				<button class="modal-default-button" @click="close">Fechar</button>
			</div>
		</modal>
		<div class="dados">
			<b-table hover striped :items="titulos" :fields="fields">
				<template slot="actions" slot-scope="data" class="text-center">
					<div v-if="verificaSePodeAcessar()">	
						<b-button class="mr-2 btn-principal" v-b-tooltip.hover title="Editar" @click="editar(data.item)">
							<i class="fa fa-pencil"></i>
						</b-button>
						<b-button class="btn-principal" v-b-tooltip.hover title="Excluir" @click="chamaModal(data.item)" >
							<i class="fa fa-trash"></i>
						</b-button>
					</div>
				</template>
			</b-table>
		</div>
		<hr>
		<Paginacao v-if="totalPaginas > 1" :totalPaginas="totalPaginas" v-model="paginaAtual"/>
	</div> -->
</template>

<script>
	import metodos from '@/mixins/metodos'
	import Br from '@/config/barramento'

	export default{
		props:['titulos'],
		components: {
			//Modal
			},
		mixins: [metodos],
		data(){
			return {
				showModal: false,
				registro: {},
				totalPaginas: null,
				itensPorPagina: 5,
				paginaAtual: 1,
				fields: [
					{text: 'Titulo', value: 'nome', align: 'center', divider: true},
					{text: 'Descrição', value: 'descricao', align: 'center', divider: true},
					{text: 'Data', value: 'data', align: 'center', divider: true},
					{text: 'Ações', value: 'actions', align: 'center', divider: true},
				],
				
			}
		},
		methods:{
			chamaModal(registro){
				this.registro = registro
				this.showModal = true
			},
			close(){
				this.showModal = false
			},
			editar(titulo){
				Br.setEditarTitulo(titulo)
			},
			excluir(titulo){
				
				Br.setExcluirTitulo(titulo)
                
			},

		},

		created(){
			
		}
	}
</script>

<style scoped>
	.titulos th, .titulos tr{
		text-align: center;
	}

	.titulos .form-edicao{
		position: relative;
		z-index: 4;
	}
</style>